import { onMounted, onUnmounted } from 'vue';
import type { Ref } from 'vue';

type Callback = () => void;

const listeners = new Map<Element, Callback>();
let observer: IntersectionObserver | null = null;

function getObserver(): IntersectionObserver {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const callback = listeners.get(entry.target);
          if (callback && entry.isIntersecting) {
            callback();
            observer!.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );
  }
  return observer;
}

export function useIntersectionObserver(elRef: Ref<HTMLElement | null>, callback: Callback): void {
  onMounted(() => {
    const el = elRef.value;
    if (el) {
      const observer = getObserver();
      listeners.set(el, callback);
      observer.observe(el);
    }
  });

  onUnmounted(() => {
    const el = elRef.value;
    if (el) {
      listeners.delete(el);
      getObserver().unobserve(el);
    }
  });
}
